import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import { isEqual, uniqueId } from 'lodash';
import TimePickerInput from 'components/TimePickerInput.jsx';
import Field from 'components/Field.jsx';
import Formsy from 'lib/Formsy';
import Label from 'components/Label.jsx';
import React from 'react';

import './styles/FormTimePickerInput.scss';

export default React.createClass({
  propTypes: {
    label: React.PropTypes.node,
    labelHidden: React.PropTypes.bool,
    showErrorAfterBlur: React.PropTypes.bool,
    showErrorOnPristine: React.PropTypes.bool,
  },

  mixins: [Formsy.Mixin],

  getDefaultProps() {
    return {
      showErrorAfterBlur: false,
      showErrorOnPristine: true,
    };
  },

  getInitialState() {
    return {
      wasBlur: false,
      value: this.props.value,
    };
  },

  componentWillMount() {
    this.id = uniqueId('id-');
  },

  componentDidMount() {
    if (this.props.value) {
      this.onChange(this.props.value);
    }
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(this.props, nextProps) ||
      !isEqual(this.state, nextState)
    );
  },

  onChange(value) {
    this.setState({ value });
    this.setValue(value);
  },

  onBlur() {
    if (this.state.wasBlur === false) {
      this.setState({ wasBlur: true });
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  render() {
    let error = this.getErrorMessage();

    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
      error = null;
    }

    return (
      <Field className="FormTimePickerInput" error={error}>
        {this.renderLabel()}
        <TimePickerInput
          {...this.props}
          value={this.state.value}
          className={cx(this.props.className,
            'FormTimePickerInput-input', {
              'FormTimePickerInput-input-error': !!error,
            }
          )}
          onBlur={createChainedFunction(this.props.onBlur, this.onBlur)}
          onChange={createChainedFunction(this.props.onChange, this.onChange)}
        />
      </Field>
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/FormTimePickerInput.jsx